import React, { useEffect, useState } from "react";
import {
  getModulos,
  relacionarClientesServicio,
} from "../../componentes/http/actions/ModuloAction";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  Tooltip,
  IconButton,
} from "@mui/material";
import FilterComponent from "../../componentes/data/FilterComponent";
import AgregarClienteModuloModal from "../../componentes/modal/Modulos/AgregarClienteModuloModal";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import TrafficIcon from "@mui/icons-material/Traffic";

const GestorModulos = () => {
  const [modulos, setModulos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openClienteModal, setOpenClienteModal] = useState(false);
  const [moduloSeleccionado, setModuloSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchModulos();
  }, []);

  const fetchModulos = () => {
    setIsLoading(true);
    getModulos(localStorage.getItem("token"))
      .then((response) => {
        setModulos(Array.isArray(response) ? response : []);
      })
      .catch((error) => {
        console.log(error);
        setModulos([]);
        setSnackbar({
          open: true,
          message: "Error al cargar módulos",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  // Filtros y paginación
  const filteredModulos = modulos
    .filter((modulo) => {
      const matchesSearch = modulo.servicio
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && modulo.habilitado === true) ||
        (filterHabilitado === "deshabilitado" && modulo.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0);
  };

  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0);
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const handleRelacionarClientes = async (relacion) => {
    try {
      setIsLoading(true);
      await relacionarClientesServicio(
        localStorage.getItem("token"),
        relacion.idModulo,
        relacion.idsClientes
      );
      setSnackbar({
        open: true,
        message: "Clientes relacionados con éxito",
        severity: "success",
      });
      fetchModulos();
      setOpenClienteModal(false);
    } catch (error) {
      console.error("Error al relacionar clientes:", error);
      setSnackbar({
        open: true,
        message: "Error al relacionar clientes",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const esSemaforo = (modulo) => {
    return modulo.servicio.toLowerCase().includes('semaforo') || 
           modulo.servicio.toLowerCase().includes('semáforo');
  };

  const handleGestionarSemaforos = () => {
    navigate('/cliente/configurar-semaforo');
  };

  const renderAccionesPorModulo = (modulo) => {
  if (esSemaforo(modulo)) {
    return (
      <Box sx={{ 
        display: "flex", 
        gap: 1, 
        alignItems: "center",
        justifyContent: "center"
      }}>
        <Tooltip title="Gestionar Clientes">
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              setModuloSeleccionado(modulo);
              setOpenClienteModal(true);
            }}
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Configurar Semáforos">
          <IconButton
            size="small"
            color="primary"
            onClick={handleGestionarSemaforos}
          >
            <TrafficIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    );
  } else {
    return (
      <Tooltip title="Gestionar Clientes">
        <IconButton
          size="small"
          color="primary"
          onClick={() => {
            setModuloSeleccionado(modulo);
            setOpenClienteModal(true);
          }}
        >
          <SettingsIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }
};

  return (
    <Grid container direction="column" spacing={2} sx={{ paddingTop: { xs: '20px', sm: '10px' } }}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Módulos</Typography>
        </Grid>
      </Grid>
      
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      
      <Grid item>
        <TableContainer component={Paper}>
          {isLoading && !initialDataLoaded ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : filteredModulos.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Id</TableCell>
                  <TableCell>Servicio</TableCell>
                  <TableCell>Clientes Asociados</TableCell>
                  <TableCell>Habilitado</TableCell>
                  <TableCell sx={{ display: "flex", justifyContent: "center" }}>
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredModulos.map((modulo, index) => (
                  <TableRow key={index}>
                    <TableCell>{modulo.id}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {modulo.servicio}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {modulo.clientes && modulo.clientes.length > 0 ? (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {modulo.clientes.map((cliente, idx) => (
                            <Chip
                              key={idx}
                              label={cliente.nombre}
                              size="small"
                              variant="outlined"
                            />
                          ))}
                        </Box>
                      ) : (
                        "Sin clientes asociados"
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={modulo.habilitado ? "Sí" : "No"}
                        color={modulo.habilitado ? "success" : "error"}
                        variant="contained"
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        {renderAccionesPorModulo(modulo)}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Box p={3}>
              <Typography>
                No se encontraron módulos con los criterios de búsqueda actuales.
              </Typography>
            </Box>
          )}
        </TableContainer>
        
        <TablePagination
          component="div"
          count={modulos.filter((modulo) => {
            const matchesSearch = modulo.servicio
              .toLowerCase()
              .includes(searchTerm.toLowerCase());
            const matchesFilter =
              filterHabilitado === "todos" ||
              (filterHabilitado === "habilitado" && modulo.habilitado === true) ||
              (filterHabilitado === "deshabilitado" && modulo.habilitado === false);
            return matchesSearch && matchesFilter;
          }).length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
        />
      </Grid>

      {/* Modal para gestionar clientes */}
      <AgregarClienteModuloModal
        open={openClienteModal}
        onClose={() => setOpenClienteModal(false)}
        onSubmit={handleRelacionarClientes}
        modulo={moduloSeleccionado}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorModulos;